import { ArticleCardLarge } from '@features/articles/article-card/Large/index.tsx';
import type { Article } from '@shared/types/articles';
import { Loader } from '@src/library/components/common/index.ts';

export const getArticleLargeCardBody = ({
  articleData,
  isArticleLoading,
}: {
  isArticleLoading: boolean;
  articleData?: Article;
}) => {
  if (isArticleLoading) {
    return <Loader />;
  }
  if (articleData) {
    return <ArticleCardLarge {...articleData} />;
  }
  return 'error';
};
